export default "__VITE_ASSET__DHJ$AFSq__"